export const OPACITY_TRANSITIONS = Object.freeze({
    from: {
        opacity: 0
    },
    enter: {
        opacity: 1
    },
    leave: {
        opacity: 0
    }
});
